import React from 'react';

import AwardBlock from 'components/redesignStudent/award/awardBlock';

import PdfNoDataText from '../../../portfolio3/features/pdf/components/PdfNoDataText';
import { IModifiedReward } from '../../../types';

import './index.scss';

interface IPdfCommonRewardsProps {
  rewards: IModifiedReward[];
}

const PdfCommonRewards: React.FC<IPdfCommonRewardsProps> = ({ rewards }) => (
  <div className="pdf-common-rewards">
    {rewards.map((reward) => (
      <AwardBlock key={reward.id} award={reward} loading={false} forPdf />
    ))}
    {rewards.length === 0 && <PdfNoDataText />}
  </div>
);

export default PdfCommonRewards;
